module.exports = __webpack_public_path__ + "media/home_compressed.e605d216.mp4";